import Theme from './theme/index.vue'
import Language from './Language.vue'
import Pairing from './pairing/index.vue'
import About from './about/index.vue'

export default {
  theme: Theme,
  language: Language,
  pairing: Pairing,
  about: About,
} as Record<string, any>
